import { Sheet, SheetContent } from '@/components/ui/Sheet';
import React from 'react';
import MatchIntroScreen from './MatchIntroScreen';

type UserMatchPanelProps = {
  showIntro: boolean;
  dialogTitle: any;
  dialogBody: any;
  matchFooter: any;
  open: boolean;
  closePanel: Function;
  setShowIntro: Function;
};

const UserMatchPanel = ({
  showIntro,
  dialogTitle,
  dialogBody,
  matchFooter,
  open,
  closePanel,
  setShowIntro
}: UserMatchPanelProps) => {
  return (
    <Sheet open={open} onOpenChange={() => closePanel()}>
      <SheetContent key="messages-panel" className="w-screen md:max-w-md p-0">
        {showIntro && <MatchIntroScreen setShowIntro={setShowIntro} />}
        {dialogTitle && <div className="text-lg font-medium text-gray">{dialogTitle}</div>}
        {dialogBody}
        {matchFooter}
      </SheetContent>
    </Sheet>
  );
};

export default UserMatchPanel;
